<template>
  <v-ons-page :modifier="searchNormalize ? 'over-bottom-toolbar' : ''">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ isSubscription ? "S'inscrire (2/2)" : "Mes OS" }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList">
        <span v-if="errorMsgList.errorDuplicate">
          - <a href="#" @click="login">Connectez-vous</a> pour accéder à ce compte
          <br />
        </span>
      </app-error-msg>

      <p style="padding: 0 14px">
        <v-ons-search-input ref="inputSearch" placeholder="Recherchez une coopérative ou un négoce" v-model="search"
                            :modifier="$mdModifier" @keyup.enter="closeKeyboard"></v-ons-search-input>
      </p>

      <template v-if="! searchNormalize && userNegoce.length">
        <v-ons-list-title modifier="perflist">
          Accès ouvert{{ userNegoce.length > 1 ? 's' : '' }}
        </v-ons-list-title>
        <v-ons-list modifier="noborder">
          <v-ons-list-item v-for="item in userNegoce" :key="item" modifier="perfcours nodivider">
            <div class="center">
              {{ item }}
            </div>
            <div class="right">
              <v-ons-checkbox :disabled="true" modifier="material" :value="item" v-model="userNegoce"></v-ons-checkbox>
            </div>
          </v-ons-list-item>
          <v-ons-list-item v-if="! isTech && checkbox.length" modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="isShowAlertChange.step1 = true">
              Changer d'OS
            </v-ons-button>
          </v-ons-list-item>
        </v-ons-list>
      </template>

      <template v-if="! searchNormalize && selection.length">
        <v-ons-list-title modifier="perflist">
          Accès en attente de validation par l'OS
        </v-ons-list-title>
        <v-ons-list modifier="noborder">
          <v-ons-list-item v-for="item in selection" :key="item" modifier="perfcours nodivider">
            <div class="center" @click="selectNegoce(item, false)">
              {{ item }}
            </div>
            <div class="right">
              <v-ons-checkbox modifier="material" :value="item" v-model="checkbox"></v-ons-checkbox>
            </div>
          </v-ons-list-item>
        </v-ons-list>
      </template>

      <template v-if="! searchNormalize && suggest.length">
        <v-ons-list-title v-if="userNegoce.length || selection.length" modifier="perflist">
          Autres OS
        </v-ons-list-title>
        <v-ons-list modifier="noborder">
          <v-ons-list-item v-for="item in suggest" :key="item" modifier="perfcours nodivider">
            <div class="center" @click="selectNegoce(item, false)">
              {{ item }}
            </div>
            <div class="right">
              <v-ons-checkbox modifier="material" :value="item" v-model="checkbox"></v-ons-checkbox>
            </div>
          </v-ons-list-item>
        </v-ons-list>
      </template>

      <v-ons-list v-if="searchNormalize" modifier="noborder">

        <v-ons-list-item v-for="negoceItem in searchList" modifier="perfcours nodivider" :key="negoceItem"
                         @click="selectNegoce(negoceItem, true)" tappable>
          <div class="center">
            {{ negoceItem }}
          </div>
          <div class="right">
            <v-ons-checkbox modifier="material"></v-ons-checkbox>
          </div>
        </v-ons-list-item>
        
        <v-ons-list-item v-if="searchList.length == 25" modifier="perfcours nodivider" key="many">
          <div class="center">
            <span class="label-grey">
              Affinez votre recherche
            </span>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="! searchList.length" modifier="perfcours nodivider" key="none">>
          <div class="center">
            <span class="label-grey">
              Aucun résultat trouvé
            </span>
          </div>
        </v-ons-list-item>

      </v-ons-list>

      <div v-if="! userNegoce.length && ! selection.length && ! suggest.length && ! searchNormalize" class="content--perfalert__empty"
           style="height: calc(100% - 60px);">
        <section>
          <img src="../assets/imgs/icon_wait_bg@2x.png" @click="searchFocus" />
          <h3>Ajoutez tous vos OS&nbsp;!</h3>
          <p>
            {{ isSubscription ? 'Finalisez votre inscription' : 'Complétez votre compte' }}
            en ajoutant les OS (coopératives, négoces ...) à qui vous vendez votre marchandise.
          </p>
        </section>
      </div>

    </div>

    <v-ons-bottom-toolbar v-if="! searchNormalize.length" modifier="cta background">
      <v-ons-button v-if="isBlockAll !== undefined"
                    :modifier="isBlockAll ? 'outline perflarge' : 'outline perflarge erreur'" @click="blockAll">
        {{ isBlockAll ? 'Ré-activer' : 'Suspendre' }} les ventes
        <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </v-ons-button>
      <template v-else-if="! checkbox.length && ! userNegoce.length">
        <v-ons-button v-if="! selection.length && ! suggest.length" modifier="large--cta perflarge" @click="searchFocus">
          Ajouter mes OS
        </v-ons-button>
        <div v-else>
          Sélectionner mes OS,<br />
          ou <a href="#" @click="searchFocus">Rechercher</a>
        </div>
      </template>
      <div v-else-if="! isTech && (checkbox.length + userNegoce.length) == 1">
        Ajouter d'autres OS,<br />
        ou <a href="#" @click="save">{{ isSubscription ? 'Valider' : 'Enregistrer' }}</a>
        &nbsp;<v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </div>
      <v-ons-button v-else modifier="large--cta perflarge" @click="save" :disabled="isTech">
        {{ isSubscription ? "Valider mon inscription" : 'Enregistrer mes OS' }}
        <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </v-ons-button>
    </v-ons-bottom-toolbar>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShowAlertChange.step1"
                        cancelable>
      <template slot="title">
        Changement d'OS
      </template>
      <v-ons-list v-if="isShowAlertChange.step2" modifier="noborder nopadding transparent">
        <app-label input-id="radioSwitchOS" label="Sélectionnez le nouvel OS que vous souhaitez suivre :" :error-msg-list="errorMsgListAlert">
        </app-label>
        <v-ons-list-item v-for="item in checkbox" :key="item" modifier="nodivider perfradio" tappable
                         :class="{ 'label--invalid': errorMsgListAlert.radioSwitchOS }">
          <div class="left">
            <v-ons-radio modifier="material" :input-id="'radioOS' + item" :value="item" v-model="switchOS">
            </v-ons-radio>
          </div>
          <label class="center" :for="'radioOS' + item">
            {{ item }}
          </label>
        </v-ons-list-item>
      </v-ons-list>
      <template v-else>
        &#x26A0; Attention ! L'application vous permet de suivre les prix d'un seul OS à la fois.
        Pour chaque changement, les deux OS concernés seront notifiés.
      </template>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShowAlertChange.step1 = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="changeOS">
          {{ isShowAlertChange.step2 ? 'Valider' : 'Continuer' }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsInscription from '../mixins/inscription.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';

import AppLoginEmail from './LoginEmail.vue';
import AppParamsFerme from './ParamsFerme.vue';

export default {
  mixins: [mixinsCommons, mixinsInscription],
  components: { AppErrorMsg, AppLabel },
  props: ['pageStack'],
  data() {
    return {
      userNegoce: [],
      checkbox: [],
      selection: [],
      suggest: [],
      search: '',
      subscription: {},
      isShowAlertChange: {
        step1: false,
        step2: false
      },
      switchOS: '',
      errorMsgListAlert: {},
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isSubscription() {
      return Object.keys(this.subscription).length;
    },
    isTech() {
      return ! this.isSubscription && this.negoce[0] && this.negoce[0].is_tech;
    },
    isBlockAll() {
      if(this.isTech){
        return this.negoce[0].block_all;
      }
    },
    searchNormalize() {
      return this.normalize(this.search);
    },
    searchList() {
      if(! this.searchNormalize){
        return [];
      }
      var list = this.data.negoce.request.filter(function(currentValue) {
        return ! this.userNegoce.includes(currentValue)
          && this.normalize(currentValue).includes(this.searchNormalize);
      }, this);
      list.splice(25);
      return list;
    }
  },
  watch: {
    'isShowAlertChange.step1'(value) {
      if(! value){
        this.isShowAlertChange.step2 = false;
        this.switchOS = '';
        this.errorMsgListAlert = {};
      }
    }
  },
  methods: {
    login() {
      var email = this.subscription.email;
      this.pageStack.push({
        extends: AppLoginEmail,
        data() {
          return {
            email: email
          }
        }
      });
    },
    searchFocus(){
      this.showKeyboard();
      this.$setAutoFocus(this.$el, 'ons-search-input');
    },
    selectNegoce(value, isFromSearch){
      if(isFromSearch && ! this.selection.includes(value)){
        if(this.suggest.includes(value)){
          this.suggest.splice(this.suggest.indexOf(value), 1)
        }
        this.suggest.splice(0, 0, value);
      }
      if(! this.checkbox.includes(value)){
        this.checkbox.push(value);
      }
      this.search = '';
      if(isFromSearch){
        this.searchFocus();
        /*
        // ons-search-input sort de l'écran
        this.$nextTick(function(){
          if(this.$refs.listTitleOS){
            this.$el.scrollTop = this.$refs.listTitleOS.$el.offsetTop;
          }
        });
        */
      }
    },
    async save() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      if (this.isSubscription) {

        const body = {};
        for (const key in this.subscription) {
          body[key] = this.subscription[key];
        }
        const pushToken = localStorage.getItem('push_token');
        if (pushToken) {
          body.push_token = pushToken;
        }
        body.request = this.checkbox;

        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        const callPath = this.$apiDomain + '/inscription';
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.inscription(response);

        } catch(error) {
          if (error.status == 409) {
            this.setErrorMsgList('errorDuplicate', "Un compte Perfarmer existe déjà avec cet email");
            this.handleError(null);
          } else {
            this.handleError(error, "de l'inscription");
          }
        }
      } else {
        const body = {
          id: this.user.id,
          date: this.user.date,
          data: {
            select: this.checkbox,
            switch: this.switchOS
          }
        };
        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        const callPath = this.$apiDomain + this.getPath('/negoce/request');
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.updateUserFromResponse(response.user);

          if(response.multi && Object.keys(response.multi).length){
            this.$emit('set-multi', response.multi);
          }

          if(response.negoce){
            store.data.negoce = response.negoce;
            this.ionicStorage.set('negoce', response.negoce);
          }

          if(! this.user.ferme.nom){
            this.pageStack.push({
              extends: AppParamsFerme,
              data() {
                return {
                  workflow: 'negoceRequest'
                }
              }
            });
            this.isSubmit = false;
            this.isShowAlertChange.step1 = false;
          } else {
            this.pageStack.length > 1 && this.pageStack.pop();
            if(! this.userNegoce.length){
              this.$ons.notification.alert({
                  modifier: this.$mdModifier,
                  title: "C'est noté !",
                  message: "Vous serez notifié dès qu'un de vos OS aura accepté votre demande."
              });
            } else if(this.switchOS){
              this.$ons.notification.alert({
                  modifier: this.$mdModifier,
                  title: "C'est noté !",
                  message: "Vous serez notifié dès que votre demande aura été acceptée."
              });
            }
          }
        } catch(error) {
            this.handleError(error);
        }
      }
    },
    changeOS() {
      if(! this.isShowAlertChange.step2){
        this.isShowAlertChange.step2 = true;
      } else if(! this.switchOS){
        this.$set(this.errorMsgListAlert, 'radioSwitchOS', true);
      } else {
        this.save();
      }
    },
    async blockAll() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      const fetchInit = this.$getFetchInit('DELETE');
      fetchInit.body = JSON.stringify({
        id: this.user.id,
        date: this.user.date,
        id_negoce: this.negoce.map(item => { return item.id }),
        block_all: ! this.isBlockAll
      });
      const callPath = this.$apiDomain + this.getPath('/negoce/block');
      try {
        const response = await this.handleRequest(callPath, fetchInit);
        // avant sinon inversé post maj negoce
        var notifMsg = "Les ventes ont bien été " + (this.isBlockAll ? 'ré-activées' : 'suspendues') + ".";

        store.data.negoce = response.negoce;
        this.ionicStorage.set('negoce', response.negoce);

        this.$ons.notification.alert({
            modifier: this.$mdModifier,
            title: "C'est noté !",
            message: notifMsg
        });

        this.pageStack.length > 1 && this.pageStack.pop();
      } catch(error) {
          this.handleError(error, 'de la ' + (this.isBlockAll ? 'Ré-activation' : 'Suspension'));
      }
    }
  },
  created() {
    if (! this.isSubscription) {
      for (let i = 0; i < this.negoce.length; i++) {
        this.userNegoce.push(this.negoce[i].request || this.negoce[i].label);
      }
      if(this.user.request){
        this.checkbox = JSON.parse(JSON.stringify(this.user.request));
        this.selection = JSON.parse(JSON.stringify(this.user.request));
      }
      for (let i = 0; i < this.data.negoce.suggest.length; i++) {
        var request = this.data.negoce.suggest[i];
        if(! this.selection.includes(request) && ! this.userNegoce.includes(request)){
          this.suggest.push(request);
        }
      }
    }
  }
}
</script>

<style>
.search-input:invalid {
  border: 1px solid #e8612d;
}
.page-with-bottom-toolbar > .page--over-bottom-toolbar__content {
  bottom: 0;
}
</style>